module.exports = __webpack_public_path__ + "static/media/CodereGrey.4351dcb9.png";